<template>
  <PartnersGrid center >
    <PartnersCard v-for="(partner, i) in partners" :key="i" class="rounded-[20px] h-[144px] lg:w-full w-[240px] lg:mx-0 mx-auto flex justify-center items-center border-b-2 border-r-2 border-gray-50">
      <a :href="partner.href"  class="" target="_blank">
        <img class="object-contain  w-[250px]" :src="partner.src.filename" :alt="partner.name" />
      </a>
    </PartnersCard>
  </PartnersGrid>
</template>

<script setup>
import PartnersGrid from "../PartnersGrid.vue";
import PartnersCard from "../PartnersCard.vue";

defineProps({
  partners: {
    type: Array,
    default: () => [],
  },
});

const SupportPartner = [
   {
     src: "/assets/partners/apek.png",
     name: "APEK",
     href: "https://www.apek.cz/",
   },
 ];
function getCornerClasses(index, totalItems, cols) {
  const classes = []
  const row = Math.floor(index / cols)
  const col = index % cols

  const totalRows = Math.ceil(totalItems / cols)

  const isFirstRow = row === 0
  const isLastRow = row === totalRows - 1
  const isFirstCol = col === 0
  const isLastCol = (col === cols - 1) || (index === totalItems - 1 && isLastRow)
  const isSecondToLastRow = (row === totalRows - 2)
  const lastRowIsNotFull = totalRows * cols !== totalItems

  if (isFirstRow && isFirstCol) classes.push('rounded-tl-[20px]')
  if (isFirstRow && isLastCol) classes.push('rounded-tr-[20px]')
  if (isLastRow && isFirstCol) classes.push('rounded-bl-[20px]')
  if (isLastRow && isLastCol) classes.push('rounded-br-[20px]')
  if (isFirstCol && isLastRow) classes.push('rounded-bl-[20px]')
  if (isLastCol && isSecondToLastRow && lastRowIsNotFull) classes.push('rounded-br-[20px]')

  return classes
}


</script>

<style>
</style>
